import { Drawer, type DrawerProps, styled } from "@mui/material"
import type { MouseEvent, PropsWithChildren } from "react"

export interface SidePanelProps extends SidePanelStyle {
  open: boolean
  onClose: () => void
}

interface SidePanelStyle {
  size?: "full" | "medium"
  variant?: Extract<DrawerProps["variant"], "temporary" | "persistent">
  elevation?: DrawerProps["elevation"]
}

export const SidePanel = ({
  open,
  onClose,
  variant = "persistent",
  size = "medium",
  elevation = 16,
  children,
}: PropsWithChildren<SidePanelProps>) => {
  const handleClose = (
    event: MouseEvent | MouseEvent<HTMLButtonElement, MouseEvent>,
  ) => {
    event.stopPropagation()
    onClose()
  }

  return (
    <SidePanelEl
      open={open}
      onClose={(event: MouseEvent) => handleClose(event)}
      anchor="right"
      size={size}
      variant={variant}
      elevation={elevation}
    >
      {children}
    </SidePanelEl>
  )
}

const SidePanelEl = styled(Drawer)<SidePanelStyle>(
  ({ theme, size, elevation, variant }) => ({
    "& .MuiDrawer-paper": {
      ...(size === "medium" && {
        top: "auto",
        bottom: 10,
        height: "88%",
      }),
      width: "clamp(430px, 35%, 500px)",
      ...(variant === "persistent" &&
        elevation && {
          boxShadow: theme.shadows[elevation],
        }),
    },
  }),
)
